import { makeStyles } from "@mui/styles";
import { DateRangePicker, type Range } from "react-date-range";
import * as locales from "react-date-range/dist/locale";
import { getCalendarLocale, getLocale } from "src/i18n";

interface CalendarRangeProps {
    staticRange?: any;
    state?: Range[];
    disableFuture?: (date: Date) => boolean;
    handleSetState: (states: Range[]) => void;
}

const useStyles = makeStyles(() => ({
    calendar: {
        fontSize: 12,
    },
}));

const locale = getLocale();
const calendarLocale = getCalendarLocale(locale);

export function CalendarRange({
    staticRange,
    state,
    disableFuture,
    handleSetState,
}: CalendarRangeProps): JSX.Element {
    const classes = useStyles();
    return (
        <DateRangePicker
            className={classes.calendar}
            direction="horizontal"
            disabledDay={(date) => (disableFuture ? disableFuture(date) : false)}
            inputRanges={[]}
            locale={locales[calendarLocale]}
            months={2}
            onChange={(item) => {
                handleSetState([item.selection]);
            }}
            rangeColors={["primary"]}
            ranges={
                state.map((state) => {
                    return { ...state, color: "#394DFF" };
                }) ?? []
            }
            staticRanges={staticRange}
            weekStartsOn={1}
        />
    );
}
